/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ProductGalleryThumbnailImageComponent from './ProductGalleryThumbnailImage.component';

/** @namespace Scandipwa/Component/ProductGalleryThumbnailImage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    cloudinaryStatus: state.ConfigReducer.isCloudinaryCDNActive
});

/** @namespace Scandipwa/Component/ProductGalleryThumbnailImage/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Scandipwa/Component/ProductGalleryThumbnailImage/Container */
export class ProductGalleryThumbnailImageContainer extends Component {
    static propTypes = {
        media: PropTypes.shape({
            label: PropTypes.string,
            file: PropTypes.string,
            media_type: PropTypes.string,
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ]),
            thumbnail: PropTypes.shape({
                url: PropTypes.string
            })
        }).isRequired,
        index: PropTypes.number.isRequired,
        onActiveImageChange: PropTypes.func.isRequired,
        isActiveImage: PropTypes.bool,
        // eslint-disable-next-line react/boolean-prop-naming
        cloudinaryStatus: PropTypes.bool.isRequired,
        isLoading: PropTypes.bool.isRequired
    };

    static defaultProps = {
        isActiveImage: false
    };

    containerProps = () => {
        const {
            media,
            index,
            onActiveImageChange,
            cloudinaryStatus,
            isActiveImage,
            isLoading
        } = this.props;

        return ({
            media,
            index,
            onActiveImageChange,
            cloudinaryStatus,
            isActiveImage,
            isLoading
        });
    };

    render() {
        return (
            <ProductGalleryThumbnailImageComponent
              { ...this.containerProps() }
            />
        );
    }
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ProductGalleryThumbnailImageContainer)
);
